import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col } from 'antd';
import formatPrice from '~helpers/currency';
import { camelCaseToUpperFirstCase } from '~helpers';

export default class TransferModal extends React.Component {
  render() {
    const { record, t } = this.props;
    if (!record) {
      return false;
    }
    return (
      <Modal
        visible={!!this.props.record}
        onCancel={() => {
          this.props.onCancel(null);
        }}
        footer={null}
        width={'880px'}
        zIndex={10000000}
        wrapClassName="transfer-modal"
      >
        <div className="transfer-modal__content">
          <h3 className="transfer-modal__title">
            {t('landlord.long_tail.booking_details.transfer_modal.title.transfer_details')}
          </h3>
          <label className="transfer-modal__label">
            {t('landlord.long_tail.booking_details.transfer_modal.label.transfer_info')}
          </label>
          <Row>
            <Col span={8}>
              <span className="transfer-modal__field-name">
                {t('landlord.long_tail.booking_details.transfer_modal.field.transfer_amount')}
              </span>
            </Col>
            <Col span={16}>
              <span className="transfer-modal__field-value">
                {formatPrice(record.amount, record.currency, 2)}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span className="transfer-modal__field-name">
                {t(
                  'landlord.long_tail.booking_details.transfer_modal.field.actual_transfer_method',
                )}
              </span>
            </Col>
            <Col span={16}>
              <span className="transfer-modal__field-value">
                {record.actualTransferMethod
                  ? t(
                      `landlord.long_tail.booking_details.label.refund_info.refund_method.${record.actualTransferMethod.toLowerCase()}`,
                    )
                  : '-'}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <span className="transfer-modal__field-name">
                {t(
                  'landlord.long_tail.booking_details.transfer_modal.field.actual_transfer_details',
                )}
              </span>
            </Col>
          </Row>
          <If condition={record.actualTransferDetails}>
            <For
              of={Object.keys(
                record.actualTransferMethod !== 'BANK_TRANSFER'
                  ? record.actualTransferDetails
                  : record.actualTransferDetails.data,
              )}
              each="key"
            >
              <Row key={key}>
                <Col span={8}>
                  <span className="transfer-modal__field-name">
                    {camelCaseToUpperFirstCase(key)}
                  </span>
                </Col>
                <Col span={16}>
                  <If condition={record.actualTransferMethod !== 'BANK_TRANSFER'}>
                    <span className="transfer-modal__field-value">
                      {record.actualTransferDetails[key] || '-'}
                    </span>
                  </If>
                  <If condition={record.actualTransferMethod === 'BANK_TRANSFER'}>
                    <span className="transfer-modal__field-value">
                      {record.actualTransferDetails.data[key] || '-'}
                    </span>
                  </If>
                </Col>
              </Row>
            </For>
          </If>
        </div>

        <div className="transfer-modal__footer">
          <Button
            type="primary"
            size="large"
            onClick={() => {
              this.props.onCancel(null);
            }}
          >
            {t('landlord.long_tail.booking_details.transfer_modal.btn.close')}
          </Button>
        </div>
      </Modal>
    );
  }
}

TransferModal.propTypes = {
  t: PropTypes.func,
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

TransferModal.defaultProps = {
  t: () => {},
  onCancel: () => {},
  record: null,
};
